<div *ngIf="claim">
<!--    Title-->
    <div style="display: flex; flex-direction: row">
        <span class="typography-title-m mr-2">{{ 'my_claims.incidence_number' | translate }} {{ claim.caseNumber }}</span
        ><app-badge-status statusText="{{ claim.statusi18nkey || '' | translate }}" [iconClass]="getClaimActions(claim)[claim.status].iconBadgeClass || ''">></app-badge-status>
    </div>

<!--    Customer name-->
    <div *ngIf="claim.homeOwnerFirstName || claim.homeOwnerLastName" style="word-wrap: break-word; margin-bottom: 0.5rem">
        <span class="typography-body-m-light">
            {{ 'my_claims.customer' | translate }}: <span class="primaryDefault-color typography-body-m-medium">{{ claim.finalCustomerName }}</span></span
        >
    </div>
<!--    Customer information-->
    <div *ngIf="claim.homeOwnerFirstName || claim.homeOwnerLastName" class="justify-start items-start lg:gap-8 md:gap-4 flex flex-col md:flex-row">
        <div class="justify-start items-start gap-2 flex">
            <div class="relative">
                <svg width="10" height="18" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5 6.31543C5.27778 6.31543 5.51378 6.2181 5.708 6.02343C5.90267 5.82921 6 5.59321 6 5.31543C6 5.03765 5.90267 4.80165 5.708 4.60743C5.51378 4.41276 5.27778 4.31543 5 4.31543C4.72222 4.31543 4.48622 4.41276 4.292 4.60743C4.09733 4.80165 4 5.03765 4 5.31543C4 5.59321 4.09733 5.82921 4.292 6.02343C4.48622 6.2181 4.72222 6.31543 5 6.31543ZM5 12.1488C6.38889 10.9377 7.45822 9.72654 8.208 8.51543C8.95822 7.30432 9.33333 6.2821 9.33333 5.44876C9.33333 4.13765 8.914 3.06543 8.07533 2.2321C7.23622 1.39876 6.21111 0.982096 5 0.982096C3.78889 0.982096 2.764 1.39876 1.92533 2.2321C1.08622 3.06543 0.666667 4.13765 0.666667 5.44876C0.666667 6.2821 1.04178 7.30432 1.792 8.51543C2.54178 9.72654 3.61111 10.9377 5 12.1488ZM5 13.0654C3.31111 11.5654 2.05556 10.1765 1.23333 8.89876C0.411111 7.62099 0 6.47099 0 5.44876C0 3.8821 0.502889 2.63499 1.50867 1.70743C2.514 0.77943 3.67778 0.31543 5 0.31543C6.32222 0.31543 7.48622 0.77943 8.492 1.70743C9.49733 2.63499 10 3.8821 10 5.44876C10 6.47099 9.58889 7.62099 8.76667 8.89876C7.94444 10.1765 6.68889 11.5654 5 13.0654Z"
                        fill="#232323"
                    />
                </svg>
            </div>
            <div class="text-xs font-normal leading-[18px]">
                {{ claim.homeOwnerStreet }}, {{ claim.homeOwnerState }}, {{ claim.homeOwnerCity }}. {{ claim.homeOwnerPostalCode }}
            </div>
        </div>
        <div class="justify-start items-start gap-2 flex">
            <div class="relative">
                <svg width="12" height="18" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.08333 10.3148C0.772222 10.3148 0.514 10.2121 0.308667 10.0068C0.102889 9.801 0 9.54256 0 9.23145V2.06478C0 1.75367 0.102889 1.49545 0.308667 1.29011C0.514 1.08433 0.772222 0.981445 1.08333 0.981445H10.9167C11.2278 0.981445 11.4862 1.08433 11.692 1.29011C11.8973 1.49545 12 1.75367 12 2.06478V9.23145C12 9.54256 11.8973 9.801 11.692 10.0068C11.4862 10.2121 11.2278 10.3148 10.9167 10.3148H1.08333ZM6 5.73145L0.666667 2.23145V9.23145C0.666667 9.35367 0.705556 9.45367 0.783333 9.53145C0.861111 9.60922 0.961111 9.64811 1.08333 9.64811H10.9167C11.0389 9.64811 11.1389 9.60922 11.2167 9.53145C11.2944 9.45367 11.3333 9.35367 11.3333 9.23145V2.23145L6 5.73145ZM6 4.98145L11.1333 1.64811H0.866667L6 4.98145ZM0.666667 2.23145V1.64811V9.23145C0.666667 9.35367 0.705556 9.45367 0.783333 9.53145C0.861111 9.60922 0.961111 9.64811 1.08333 9.64811H0.666667V9.23145V2.23145Z"
                        fill="#232323"
                    />
                </svg>
            </div>
            <div class="text-xs font-normal leading-[18px]">{{ claim.homeOwnerEmail }}</div>
        </div>
        <div class="justify-start items-start gap-2 flex">
            <div class="relative">
                <svg width="12" height="18" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.5992 10.8988C9.44366 10.8988 8.27433 10.6043 7.09122 10.0154C5.90766 9.42654 4.84366 8.65721 3.89922 7.70743C2.95477 6.75721 2.18544 5.69321 1.59122 4.51543C0.996552 3.33765 0.699219 2.17099 0.699219 1.01543C0.699219 0.81543 0.765885 0.648763 0.899219 0.51543C1.03255 0.382096 1.19922 0.31543 1.39922 0.31543H3.03255C3.23255 0.31543 3.39922 0.370985 3.53255 0.482096C3.66589 0.593207 3.74922 0.743208 3.78255 0.932096L4.11589 2.51543C4.14922 2.69321 4.14655 2.85143 4.10789 2.9901C4.06877 3.12921 3.99366 3.24876 3.88255 3.34876L2.43255 4.71543C3.02144 5.70432 3.691 6.5681 4.44122 7.30676C5.191 8.04587 6.06589 8.69876 7.06589 9.26543L8.48255 7.79876C8.59366 7.68765 8.71877 7.60987 8.85789 7.56543C8.99655 7.52098 9.14366 7.51543 9.29922 7.54876L10.6992 7.8321C10.877 7.87654 11.0214 7.96543 11.1326 8.09876C11.2437 8.2321 11.2992 8.39321 11.2992 8.5821V10.1988C11.2992 10.3988 11.2326 10.5654 11.0992 10.6988C10.9659 10.8321 10.7992 10.8988 10.5992 10.8988ZM2.09922 4.0821L3.38255 2.91543C3.427 2.87099 3.45477 2.82099 3.46589 2.76543C3.477 2.70987 3.477 2.65432 3.46589 2.59876L3.16589 1.1821C3.14366 1.11543 3.11322 1.06543 3.07455 1.0321C3.03544 0.998763 2.98255 0.982096 2.91589 0.982096H1.54922C1.49366 0.982096 1.44922 0.998763 1.41589 1.0321C1.38255 1.06543 1.36589 1.10987 1.36589 1.16543C1.377 1.62099 1.44655 2.09587 1.57455 2.5901C1.70211 3.08476 1.877 3.5821 2.09922 4.0821ZM7.68255 9.56543C8.13811 9.78765 8.62144 9.95165 9.13255 10.0574C9.64366 10.1628 10.0881 10.221 10.4659 10.2321C10.5103 10.2321 10.5492 10.2154 10.5826 10.1821C10.6159 10.1488 10.6326 10.1043 10.6326 10.0488V8.71543C10.6326 8.64876 10.6159 8.59321 10.5826 8.54876C10.5492 8.50432 10.4992 8.47099 10.4326 8.44876L9.19922 8.19876C9.15477 8.18765 9.11322 8.18765 9.07455 8.19876C9.03544 8.20987 8.99366 8.23765 8.94922 8.2821L7.68255 9.56543Z"
                        fill="#232323"
                    />
                </svg>
            </div>
            <div class="text-xs font-normal leading-[18px]">{{ claim.homeOwnerPhone }}</div>
        </div>
    </div>
    <div *ngIf="!readOnly &&
                !['my_claims.pending_approval',
                'my_claims.completed',
                'my_claims.completed',
                'my_claims.closed'].includes(claim.statusi18nkey || '')">
            <!-- <app-input
                [value]="this.notes"     [(ngModel)]="notes"
                class="h-10 w-100 w-full md:w-[200px]"
                [block]="true"
            /> -->
            <textarea class="border border-border-secondary mt-2 mb-2" id="comment" style="resize: none;padding:16px;width:-webkit-fill-available" [value]="this.notes"  [(ngModel)]="notes"> </textarea>
            <app-button size="medium" (onClick)="this.updateNotes()" [isFullWidth]="true">
                {{ 'my_claims.update_notes' | translate }}
            </app-button>

    </div>

<!--    Tabs-->
    <div *ngIf="!readOnly" class="cosentino-tab">
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'SUMMARY' }" (click)="setCurrentTab('SUMMARY')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.summary' | translate }}</span>
                </div>
            </div>
        </a>
        <a [ngClass]="{ 'cosentino-tab-journey we': true, active: this.currentTab == 'COMMENTS' }" (click)="setCurrentTab('COMMENTS')">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{ 'my_claims.comments' | translate }}</span>
                </div>
            </div>
        </a>
    </div>

<!--    Claim information-->
    <div *ngIf="this.currentTab == 'SUMMARY'" class="mt-8 content" style="flex: 0.75; background: white; padding: 32px">
        <div class="flex flex-col gap-0.5 items-start justify-start self-stretch">
            <div class="mb-2 flex flex-col gap-9 items-start justify-start self-stretch">
                <div class="flex flex-col gap-9 items-start justify-start self-stretch">
                    <div class="border-solid border-cold-greys-30 border-b pb-3 flex flex-row gap-0 items-start justify-start self-stretch">
                        <div class="text-left typography-title-m">{{ 'my_claims.claim_information' | translate }}</div>
                    </div>
                </div>
                <div class="flex flex-col gap-6 items-start justify-start self-stretch">
                    <div class="flex flex-col gap-4 items-start justify-start self-stretch">
                        <div class="flex flex-col gap-1 items-start justify-start">
                            <div class="text-left typography-body-m-light">{{ 'global.subject' | translate }}:</div>
                            <div class="flex flex-row gap-1 items-center justify-start">
                                <div class="text-left typography-body-m-medium">
                                    {{ claim.subject }}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-1 items-start justify-start">
                            <div class="text-left typography-body-m-light">{{ 'global.description' | translate }}:</div>
                            <div class="flex flex-row gap-1 items-center justify-start">
                                <div class="text-left typography-body-m-medium">
                                    {{ claim.description }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="claim.purchaseOrder" class="flex flex-col gap-1 items-start justify-start">
                            <div class="text-left typography-body-m-light">{{ 'create-claim.purchase_order' | translate }}:</div>
                            <div class="flex flex-row gap-1 items-center justify-start">
                                <div class="text-left typography-body-m-medium">
                                    {{ claim.purchaseOrder }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-4 items-start justify-start self-stretch">
                        <div class="flex flex-row gap-6 items-start justify-start">
                            <div class="flex flex-col gap-1 items-start justify-start">
                                <div class="text-left typography-body-m-light">{{ 'my_claims.origin' | translate }}:</div>
                                <!-- Only the first one have translation -->
                                <div class="text-left typography-body-m-medium"><span *ngIf=" claim.typologyOrigin ">{{"my_claims.typology_origin_" + claim.typologyOrigin | translate}}</span> <span *ngIf="!claim.typologyOrigin"> {{claim.typologyOriginRaw}} </span> </div>
                            </div>
                            <div class="flex flex-col gap-1 items-start justify-start">
                                <div class="text-left typography-body-m-light">{{ 'global.category' | translate }}:</div>
                                <!-- Only the first one have translation -->
                                <div class="text-left typography-body-m-medium"><span *ngIf="claim.typologyCategory">{{"my_claims.typology_category_new_" + claim.typologyCategory | translate}}</span> <span *ngIf="!claim.typologyCategory"> {{claim.typologyCategoryRaw}} </span> </div>
                            </div>
                            <div *ngIf="claim.associatedWarranty" class="flex flex-col gap-1 items-start justify-start">
                                <div class="text-left typography-body-m-light">{{ 'global.warranty' | translate }}:</div>
                                <div class="text-left typography-body-m-medium">{{ claim.associatedWarranty }} - Maran Cunnigham - (504) 899-8565</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-8 flex flex-col gap-9 items-start justify-start self-stretch">
                <div class="border-solid border-cold-greys-30 border-b pb-3 flex flex-row gap-0 items-start justify-start self-stretch">
                    <div class="text-left typography-title-m">
                        {{ 'global.materials' | translate }}
                    </div>
                </div>
                <div *ngFor="let product of claim.claimItems" class="flex flex-row gap-4 items-center justify-start">
                    <div class="border-solid border-cold-greys-30 border-r pr-4 flex flex-col md:flex-row gap-2 items-center justify-center">
                        <img *ngIf="product?.product?.pictureURL" src="{{ product?.product?.pictureURL }}?w=60&h=60&fit=crop" [alt]="product?.product?.colorDesc" class="w-[69px] h-[69px] rounded-full object-cover mr-2">
                        <app-cosentino-svg  *ngIf="!product?.product?.pictureURL" [svgName]="'no-image'" [size]="72"></app-cosentino-svg>
                        <div class="flex flex-col items-center gap-1">
                            <p class="m-0 typography-title-s text-ellipsis">
                                {{ product.productName }}
                            </p>
                            <img *ngIf="brandStringToImage(product.productBrand)" class="w-[97px]" alt="imageBrand" [src]="brandStringToImage(product.productBrand)">
                            <p *ngIf="!brandStringToImage(product.productBrand)" class="typography-body-s-medium m-0">
                                {{ product.productBrand }}
                            </p>
                        </div>
                    </div>
                    <div class="flex flex-row gap-6 items-center justify-start flex-wrap">
                        <div *ngIf="product.productFinish" class="flex flex-row gap-1 items-center justify-start">
                            <div class="text-left typography-body-m-light">{{ 'global.finish' | translate }}:</div>
                            <div class="text-left typography-body-m-medium">{{ product.productFinish }}</div>
                        </div>
                        <div *ngIf="product.productThickness" class="flex flex-row gap-1 items-center justify-start">
                            <div class="text-left typography-body-m-light">{{ 'global.thickness' | translate }}:</div>
                            <div class="text-left typography-body-m-medium">{{ product.productThickness }} cm</div>
                        </div>
                        <div *ngIf="product.productFormat" class="flex flex-row gap-1 items-start justify-start">
                            <div class="text-left typography-body-m-light">{{ 'global.format' | translate }}:</div>
                            <div class="text-left typography-body-m-medium">{{ product.productFormat }}</div>
                        </div>
                        <div class="flex flex-row gap-1 items-start justify-start">
                            <div class="text-left typography-body-m-light">{{ 'global.lot_id' | translate }}:</div>
                            <div class="text-left typography-body-m-medium">{{ product.barCode }}</div>
                        </div>
                        <div class="flex flex-row gap-1 items-start justify-start">
                            <div class="text-left typography-body-m-light">{{ 'create-claim.material-selection.table.m2_sqft' | translate }}:</div>
                            <div class="text-left typography-body-m-medium">{{ product.selectedQty | number:'1.2-2' }} {{ product?.product?.msetMeins }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!--    Claim comments-->
    <div *ngIf="this.currentTab == 'COMMENTS'" class="mt-8 content" style="flex: 0.75; background: white; padding: 32px">
        <div class="border-solid border-cold-greys-30 border-b pb-3 flex flex-row gap-0 items-start justify-start self-stretch">
            <div class="text-left typography-title-m">{{ 'my_claims.communication_with_our_team' | translate }}</div>
        </div>
        <ng-container *ngIf="claim.publicComment">
        <div class="flex flex-row gap-2 m-2 p-2">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2465_21154)"><path d="M8.16247 7.41872H15.8795L14.9099 10.331H11.286V13.5871H15.8795V16.5005H8.16247V7.41753V7.41872ZM0.0800781 23.9107H23.9607V0.00976562H0.0800781V23.9107Z" fill="#232323"/></g><defs><clipPath id="clip0_2465_21154"><rect width="24" height="24" fill="white" transform="translate(0 -0.00195312)"/></clipPath></defs></svg>
        {{'my_claims.cosentino_team' |translate}}
        </div>
        <p class="typography-body-s-regular text-text-secondary">
            {{claim.publicComment}}

        </p>
        </ng-container>
      <div class="chat__conversation">
  <div class="conversation">
    <div class="conversation__container" #conversationArea>
      <div *ngFor="let comment of claimComments; let i = index" class="mt-2 message">
        
        <!-- Fecha separadora -->
        <div *ngIf="shouldShowDate(i)" class="text-sm typography-body-s-regular text-center textTerciary-color">
          {{ comment.createdDate | date : 'fullDate' }}
        </div>

        <!-- Mensaje normal o archivo -->
        <div 
          [ngClass]="comment.createdBy === 'Salesforce Administration Cosentino' ? 'message message--sent' : 'message message--received'">
          
          <!-- Nombre de usuario (si no es SF Admin) -->
          <span *ngIf="comment.createdBy !== 'Salesforce Administration Cosentino'">
            {{ comment.createdBy }}
          </span>

          <!-- Mensaje o archivo -->
          <ng-container *ngIf="!comment.isFile; else fileTemplate">
            <div class="typography-body-m-light" [innerHTML]="comment.commentBody"></div>
          </ng-container>

          <ng-template #fileTemplate>
            <a 
              *ngIf="comment.fileId && comment.fileName && comment.fileExtension"
              download class="cursor-pointer flex items-center text-primary-default"
              style="cursor:pointer;"
              (click)="this.getDocument(claim.id,comment.fileId, comment.fileName, comment.fileExtension)"
              > {{ comment.fileName }}
            </a>
          </ng-template>
        </div>
        
      </div>
    </div>
  </div>
</div>

        <ng-container *ngIf="claim.isPendingSubmit && claim.statusi18nkey === 'my_claims.pending_approval'">
            <div class="my-4">
                <alert type="info">
                    {{'my_sales.our_team_is_evaluating_your_message' | translate}}
                </alert>
            </div>
        </ng-container>

        <ng-container *ngIf="claim.statusi18nkey === 'my_claims.pending_information'">
            <span class="typography-body-m-medium">{{"my_claims.message" |translate}}:</span>
            <textarea class="border border-border-secondary mt-2 mb-2" id="comment" style="resize: none;padding:16px;width:-webkit-fill-available" [value]="this.comment"     [(ngModel)]="comment"> </textarea>
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-4">
                    <input
                        #claimDocumentInput
                        id="claim_document_chatter"
                        type="file"
                        hidden
                        [accept]="acceptedDocumentsString"
                        (change)="onFileSelected($event)"
                    />
                    <app-button size="medium" (onClick)="this.onOpenFileSelect()" [isFullWidth]="true">
                        {{ 'my_claims.add_more_documents' | translate }}
                    </app-button>
                </div>
                <div class="col-span-8">
                    <app-button [primary]="true" size="medium" (onClick)="this.sendMessage()" [disabled]="!this.comment" [isFullWidth]="true">
                        {{ 'my_claims.send_message' | translate }}
                    </app-button>
                </div>
            </div>
        </ng-container>
    </div>

<!--    Claim documents-->
    <div class="mt-8 content" style="flex: 0.75; background: white; padding: 32px">
        <div class="flex flex-col gap-0.5 items-start justify-start self-stretch">
            <div class="mb-2 flex flex-col gap-9 items-start justify-start self-stretch">
                <div class="flex flex-col gap-9 items-start justify-start self-stretch">
                    <div class="border-solid border-cold-greys-30 border-b pb-3 flex flex-row gap-0 items-start justify-start self-stretch">
                        <div class="text-left typography-title-m">{{ 'my_claims.files_and_documents_uploaded' | translate }}</div>
                    </div>
                </div>
                <!-- Factura de compra del cliente final o de factura emitida a la tienda: -->

                <ng-container *ngFor="let document of claimDocuments">
                    <!-- <a download style="cursor:pointer;" (click)="this.getDocument(claim.id,document.versionId, document.title, document.fileExtension)">{{document.title}}.{{document.fileExtension}}</a> -->

                    <div class="grid grid-cols-[repeat(12,1fr)] gap-2 w-full">
                        <p class="col-span-12 md:col-span-9 m-0 typography-body-m-regular">
                            {{!(('create-claim.documentation.' + document.type) | translate).includes('create-claim.documentation.') ? (('create-claim.documentation.' + document.type) | translate) : ('create-claim.documentation.document' | translate)}}:&nbsp;
                        </p>
                        <a class="col-span-12 md:col-span-3 typography-body-m-regular cursor-pointer flex items-center text-primary-default"
                           (click)="this.getDocument(claim.id,document.versionId, document.title, document.fileExtension)" download>
                            <img src="assets/icons/document.svg" alt="Download">
                            {{document.title}}
                        </a>
                    </div>

                </ng-container>
                <div class="divider w-full"></div>
                <a class="typography-body-l-regular cursor-pointer flex items-center text-primary-default"
                   (click)="this.downloadAllDocuments(claim.id)" download>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path d="M6.625 19.6488C6.15833 19.6488 5.771 19.4948 5.463 19.1868C5.15433 18.8782 5 18.4905 5 18.0238V15.6488H6V18.0238C6 18.1905 6.06267 18.3362 6.188 18.4608C6.31267 18.5862 6.45833 18.6488 6.625 18.6488H17.375C17.5417 18.6488 17.6873 18.5862 17.812 18.4608C17.9373 18.3362 18 18.1905 18 18.0238V15.6488H19V18.0238C19 18.4905 18.846 18.8782 18.538 19.1868C18.2293 19.4948 17.8417 19.6488 17.375 19.6488H6.625ZM12 15.8738L8.45 12.3488L9.175 11.6238L11.5 13.9488V5.29883H12.5V13.9488L14.825 11.6238L15.55 12.3488L12 15.8738Z" fill="#365BCA"/>
                    </svg>
                    {{'my_claims.download_all_documents' | translate}}
                </a>
            </div>
        </div>
    </div>
</div>

<app-confirm-modal
    [isOpen]="isErrorModalVisible"
    title="{{ 'create-claim.documentation.error_uploading_file' | translate }}"
    message="{{errorMessage}}"
    confirmText="{{'common.buttons.close' | translate}}"
    cancelText=""
    (onConfirm)="isErrorModalVisible = false"
    (onCancel)="isErrorModalVisible = false"
    (onClose)="isErrorModalVisible = false"
/>
